import { render, staticRenderFns } from "./PageSuscribete.vue?vue&type=template&id=0a10bdf1&"
import script from "./PageSuscribete.vue?vue&type=script&lang=js&"
export * from "./PageSuscribete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports